import React, { useEffect, useRef, useState } from "react";
import DownArrow from "../../../assets/svg/downward-arrow.svg";
import UpArrow from "../../../assets/svg/upward-arrow.svg";
import DownwardArrow from "../../../assets/svg/down-arrow.svg";
import { ToastContainer, toast } from "react-toastify";
import {
  historyPageSelectedTransaction,
} from "../../../store";
import { RecoilState, useRecoilState, useRecoilValue } from "recoil";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Rotator from "../Rotater";
import { formatNumber } from "../../../utils";

// Define a type for the transaction data
type TabKeys = "Online" | "Flywire" | "Offline" | "Travel Card" | "Convera";

type TransactionList = {
  adType: string | number;
  amountPaid: string | number;
  amount: string | number;
  assignedTo: string | number;
  bankProcessingFees: string | number;
  destinationCurrency: string | number;
  exchangeRate: string | number;
  foreignCurrencyAmountReceived: string | number;
  grossCommission: string | number;
  gst: string | number;
  gstValue: string | number;
  ibr: string | number;
  nostroChargeBearingParty: string | number;
  nostroCharges: string | number;
  purpose: string;
  referrerVendor?: any;
  remitterName: string;
  recipientName?: string;
  revenuePartnerName: string | number;
  salesPerson: string | number;
  salesPersonMapped: string | number;
  totalCommsChargedInr: string | number;
  totalMarkUpCharged: string | number;
  totalNetCommissions: string | number;
  totalNetComms: string | number;
  transactionNo: string;
  transactionType: string;
  txnDate: string;
  transactionCreatedOnDate: string;
  txnNumber: string;
  usdValue: string | number;
  vendorCode: string;
  vendorFees: string | number;
  vendorName: string | number;
  vendorRate: string | number;
  amountReceived: string | number;
};

type TransactionDocsProps = [
  {
    docName: string;
    isOsv: boolean;
    idDoc: number | string;
    idNumber: string | null | number;
    createdOn: string;
    areLogsPresent: boolean;
    docPath: string;
  }
];

type DetailProps = {
  title?: string;
  show?: boolean;
  details: {
    label: string | "";
    value: string | React.ReactNode;
    important?: boolean;
  }[];
};

type DetailsMultipleDataProps = {
  title?: string;
  show?: boolean;
  details?: {
    label: string | "";
    value: string | React.ReactNode;
    important?: boolean;
    show?: boolean;
  }[];
  data?: DetailProps[];
};

type TransactionExtensionProps = {
  transactionList: TransactionList
};

type TransactionDataProps = {
  trxnData: any;
  selectedTransaction: string;
  selectedTab: string;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsCancelModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  transactionList: TransactionList
};

type NewHistoryCardTransactionProps = {
  isOpen: boolean;
  transactionsList: any;
  handleAccordionClick: (id: string) => void;
  selectedTransaction: string;
  selectedTab: string;
  loading:any;
  setLoading:any
};

type NewHistoryCardProps = {
  transactions: any;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedTab: string;
  setIsCancelModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  pagination: {
    page: number;
    size: number;
    ascending: boolean;
    totalElements: number;
    totalPages: number;
  };
};

const getDate = (date: string) => {
  const formattedDate =
    new Date(date).toLocaleDateString() +
    "," +
    new Date(date).toLocaleString("en-US", {
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });

  return formattedDate.toString();
};

export const NewHistoryCardTransaction: React.FC<
  NewHistoryCardTransactionProps
> = ({
  transactionsList,
  isOpen,
  handleAccordionClick,
  selectedTransaction,
  selectedTab,
  loading
}) => {
    const {
      amountPaid,
      destinationCurrency,
      referrerVendor,
      remitterName,
      recipientName,
      totalNetCommissions,
      transactionNo,
      transactionCreatedOnDate,
      amountReceived
    } = transactionsList as TransactionList;

    return (
      <div className="grid grid-cols-7 w-full px-2" onClick={() => {
        handleAccordionClick(transactionNo);
      }}>
        <p id="Transaction-id" className="transaction-list-design text-center">
          {transactionNo ?? ''}
        </p>
        <p id="Remitter-Name" className="transaction-list-design text-center">
          {remitterName ?? ''}
        </p>
        <p id="Recipient-Name" className="transaction-list-design text-center">
          {recipientName ?? ''}
        </p>
        <p id="Remitter-Name" className="transaction-list-design text-center">
          {transactionCreatedOnDate? getDate(transactionCreatedOnDate) : ''}
        </p>
        <p id="Remitter-Name" className="transaction-list-design text-center">
          <span>{amountPaid?.toLocaleString("en-IN")} INR</span>
           {" "} →{" "}
          <span>{amountReceived?.toLocaleString("en-US") + " " + destinationCurrency}</span>
        </p>
        <p id="Remitter-Name" className="transaction-list-design text-center">
          {totalNetCommissions ? `${formatNumber(totalNetCommissions)} INR` : '0 INR'}
        </p>
        <div id="Vendor-code" className="transaction-list-design text-center flex items-center pl-[40%]">
          <p className="min-w-[46px]">
            {referrerVendor || "N/A"}
          </p>
          <div
            id="Drop-down-icon"
            className="flex items-center justify-center pl-8 cursor-pointer"
            onClick={() => { 
              handleAccordionClick(transactionNo);
            }}
          >
          {loading && transactionNo === selectedTransaction && isOpen ? (
            <Rotator/>
          ) : (
            <img
              src={
                isOpen && transactionNo === selectedTransaction
                  ? UpArrow
                  : DownArrow
              }
              alt="toggle"
            />
          )}
          </div>
        </div>
      </div>
    );
  };

// main component that renders whole history page component.
const NewHistoryCard: React.FC<NewHistoryCardProps> = ({
  transactions,
  setIsModalOpen,
  pagination,
  selectedTab,
  setIsCancelModalOpen,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedTransaction, setSelectedTransaction] = useRecoilState<string>(
    historyPageSelectedTransaction
  );
  const [loading, setLoading] = React.useState(false);
  const [trxnData, setTrxnData] = React.useState<any>({});

  const handleAccordionClick = (transactionId: string | number | undefined) => {
    setIsOpen(true);
    if (!transactionId) return;

    const id = transactionId.toString();

    if (selectedTransaction === id) {
      setSelectedTransaction("");
      setIsOpen(false);
    } else {
      setSelectedTransaction(id);
      setIsOpen(true);
    }
  };

  return (
    <div id="New-History-Card">
      <ToastContainer position="top-center" />
      <div
        id="History-Card-Accordion"
        className={`${selectedTab !== "Online" ? "border border-[#E8E8E8]" : " "
          }`}
      >
        <div
          id="History-Page-Transaction-list"
          className={`${selectedTab !== "Online" ? "" : " px-0 w-full "}`}
        >
          <div id="History-Page-Transaction">
            {transactions.length > 0 &&
              transactions
                ?.slice(0, pagination.size || 10)
                ?.map((transactionList: any, index: number) => 
                {
                  return(
                  <div
                    className={`${selectedTab !== "Online"
                      ? "odd:bg-white even:bg-[#F8F8FC] p-2 w-full"
                      : "my-2 bg-[#F2F2F2] p-2 w-full rounded-md"
                      }`}
                    key={index}
                  >
                    <NewHistoryCardTransaction
                      transactionsList={transactionList}
                      isOpen={isOpen}
                      selectedTransaction={selectedTransaction}
                      selectedTab={selectedTab as TabKeys}
                      handleAccordionClick={handleAccordionClick}
                      loading={loading}
                      setLoading={setLoading}
                    />
                    {isOpen &&
                      (selectedTransaction === transactionList?.transactionNo) &&
                      !loading &&
                      (
                        <div id="History-page-transaction-data">
                          <div id="Transaction-Data-Main-Component" className="mt-2">
                            <div id="main-data-component" className="p-2 grid-cols-12 w-full">
                              <TransactionDataGrids transactionList={transactionList} />
                            </div>
                          </div>
                        </div>
                    )}
                  </div>
                )
              }
                )}
          </div>
        </div>
      </div>
    </div>
  );
};

// detail component showing basic user information.
export const DetailCard: React.FC<DetailsMultipleDataProps> = ({
  data,
}) => {
  return (
    <div className="col-span-1 bg-[#F5F5F5] h-full p-4 rounded-md">
      <div className="flex flex-col">
        <div className="pt-2">
          {data && data.map(
            (item, index) =>
              item?.show && (
                <div key={index} className="pb-4">
                  {item.details.map((detail, index) => (
                    <p
                      key={index}
                      className="text-sm leading-8 text-[#646464]"
                    >
                      {detail.label ? detail.label + ":" : ""}{" "}
                      <span
                        className={`${detail?.important && "font-semibold text-black"
                          }`}
                      >
                        {detail.value ? detail.value : "NA"}
                      </span>
                    </p>
                  ))}
                </div>
              )
            )}
        </div>
      </div>
    </div>
  );
};

// 3 details card showing user details
export const TransactionDataGrids: React.FC<TransactionExtensionProps> = ({
  transactionList,
}) => {
  const transactionData = [
    [
      {
        show: true,
        details: [
          {
            label: "Transaction Type",
            value: transactionList?.transactionType,
            important: true,
            show: true,
          }
        ],
      },
    ],
    [
      {
        show: true,
        details: [
          {
            label: "Vendor Name",
            value: transactionList?.vendorName,
            important: true,
          },
          {
            label: "Vendor Fees",
            value: transactionList?.vendorFees ? `${formatNumber(transactionList?.vendorFees)} INR` : '0 INR',
            important: true,
          },
          {
            label: "Vendor Rate",
            value: transactionList?.vendorRate ? `${formatNumber(transactionList?.vendorRate)} INR` : '0 INR',
            important: true,
          },
        ],
      }
    ],
    [
      {
        show: true,
        details: [
          {
            label: "Total Comms Charged (INR)",
            value: transactionList?.totalCommsChargedInr ? `${formatNumber(transactionList?.totalCommsChargedInr)} INR` : '0 INR',
            important: true,
          },
          {
            label: "Gross Commission (VF+TC)",
            value: transactionList?.grossCommission ? `${formatNumber(transactionList?.grossCommission)} INR` : '0 INR',
            important: true,
          },
          {
            label: "GST Value",
            value: transactionList?.gstValue ? `${formatNumber(transactionList?.gstValue)} INR` : '0 INR',
            important: true,
          },
        ],
      },
    ],
    [
      {
        show: true,
        details: [
          {
            label: "Purpose",
            value: transactionList?.purpose,
            important: true,
          }
        ],
      }
    ],
  ];
  return (
    <div
      id="transaction-data-grids"
      className="grid sm:grid-cols-1 grid-cols-2 md:grid-cols-4 gap-6 min-h-full p-2 w-full"
    >
      {transactionData.map((data, index) => {
        return <DetailCard key={index} data={data} />;
      })}
    </div>
  );
};

// download options
export const renderDownloadOptions = (
  trxnDocs: TransactionDocsProps,
  downloadingItem: { isLoading: boolean; docName: string },
  handleKYCOtherDocsDownload: (doc: string, docName: string) => void
) => {
  return (
    <div className="absolute shadow-md bg-white rounded-b-lg p-2 mt-11 max-h-28 text-sm overflow-y-scroll z-10 noscrollbar w-fit scrollbar scrollbar-track scrollbar-thumb scrollbar-hover">
      {trxnDocs.map((docs) => (
        <button
          onClick={() =>
            handleKYCOtherDocsDownload(docs?.docPath, docs?.docName)
          }
          key={docs?.idDoc}
          className={`p-2 px-4 flex focus:bg-[#383E4708] items-center justify-start ${downloadingItem?.isLoading &&
            downloadingItem?.docName === docs?.docName &&
            "cursor-wait"
            }`}
          disabled={
            downloadingItem?.isLoading &&
            downloadingItem?.docName === docs?.docName
          }
        >
          <img
            src={DownwardArrow}
            className="px-2"
            alt="Download option icon"
          />
          {docs?.docName.replace("_", " ")}
        </button>
      ))}
    </div>
  );
};

export default NewHistoryCard;
